import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeRu from '@angular/common/locales/ru';
import { Inject, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderInterceptorService, TokenInterceptorService } from '@app-core/interceptors';
import { HttpErrorInterceptorService } from '@app-core/interceptors/http-error-interceptor.service';
import { GlobalLoaderService } from '@app-core/providers/global-loader.service';
import { IconRegistryService } from '@app-core/providers/icon-registry.service';
import { InjectableTranslateMessageFormatCompilerService } from '@app-core/providers/injectable-translate-message-format-compiler.service';
import { TokenService } from '@app-core/providers/token.service';
import { UserPrincipalService } from '@app-core/providers/user-principal.service';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { ApiModule as UserApiModule } from 'cms-typescript-sdk/digitalocean/api.module';
import { ApiModule as AdminApiModule } from 'cms-typescript-sdk/unistack/api.module';
import { MESSAGE_FORMAT_CONFIG } from 'ngx-translate-messageformat-compiler';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslatePoHttpLoader(httpClient, 'assets/i18n', '.po');
}

registerLocaleData(localeRu, 'ru');
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    UserApiModule,
    AdminApiModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: InjectableTranslateMessageFormatCompilerService
      },
      isolate: false,
    })
  ],
  providers: [
    UserPrincipalService,
    GlobalLoaderService,
    TokenService,
    IconRegistryService,
    // TranslatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true
    },
    {
      provide: MESSAGE_FORMAT_CONFIG,
      useValue: {
        locales: ['en', 'ru']
      }
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(@Inject(IconRegistryService) icons) {
  }
}
